import { render, staticRenderFns } from "./warehousemanagement.vue?vue&type=template&id=0b8d86fa&scoped=true&"
import script from "./warehousemanagement.vue?vue&type=script&lang=js&"
export * from "./warehousemanagement.vue?vue&type=script&lang=js&"
import style0 from "./warehousemanagement.vue?vue&type=style&index=0&id=0b8d86fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8d86fa",
  null
  
)

export default component.exports